import React from 'react'

function Footer() {
  return (
    <div className="row justify-content-center text-center text-white py-3 bg-light" style={{marginTop:"100px"}}>
            <footer className="footer">
                <div className='text-dark'>
                    Copyright &#169; Study Buddy 2023. All Right Reserved.
                </div>
            </footer>
        </div>
  )
}

export default Footer